import { render, staticRenderFns } from "./FloatingView.vue?vue&type=template&id=2c581576&scoped=true"
import script from "./FloatingView.vue?vue&type=script&lang=js"
export * from "./FloatingView.vue?vue&type=script&lang=js"
import style0 from "./FloatingView.vue?vue&type=style&index=0&id=2c581576&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c581576",
  null
  
)

export default component.exports